// Error code returned by Backend where the menuItem in basket no longer exists in menu
export const MENU_HAS_UPDATED_ERROR_CODE = 10608;
